module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/thumbnail_Kouhei Masuda-74f69684b9d664cebc42254ead2e4518.png";